'use strict';

module.exports = function () {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/trend-indicator.html'),
    scope: {
      value: '@',
      text: '@',
      indicator: '='
    }
  };
};